import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/esm/Card'
import Controllers from '../../Api/Controllers'
import ReactPlaceholder from 'react-placeholder/lib'
import Helpers from '../../Components/Helpers/Helpers'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap'
import Modal from 'react-bootstrap/Modal'
import { Input, FormCustom, Select } from '../../Components/Form/Form'
import Button from 'react-bootstrap/esm/Button'
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux'

const Dashboard = ({ idCustomersFilter }) => {
    const [summary, setSummary] = useState([])
    const [ready, setReady] = useState(false)
    const [rows, setRows] = useState([])

    const [modalShow, setModalShow] = useState(false)
    const [modalTitle, setModalTitle] = useState('')
    const [isProcessing, setIsProcessing] = useState(false)

    const [loadSubmit, setLoadSubmit] = useState(false)
    const [idCustomers, setIdCustomers] = useState('')

    const [showData, setShowData] = useState(!idCustomersFilter)
    const [showRollOver, setShowRollOver] = useState(false);

    const [periodSelected, setPeriodSelected] = useState('');
    const [period, setPeriod] = useState([]);
    const { terms_accepted, id_type_money, type } = useSelector(state => state.session)

    const [terms, setTerms] = useState(terms_accepted === 0)

    const jwt = useSelector(store => store.session.jwt)

    const [contratoUsaData, setContratoUsaData] = useState({
        name: '',
        business_name: '',
        federal_tax: '',
        federal_tax_add: '',
        exempt_pay_code: '',
        exemption_fatca: '',
        address: '',
        city_state_zip: '',
        list_account_numbers: '',
        requests_name: '',
        social_security_number: '',
        employer_identification_number: '',
    })

    useEffect(() => {
        Controllers.period.get_period().then(res => {
            setPeriod(res.data)
        })
    }, [])

    const loadAll = _ => {
        if (idCustomersFilter && !idCustomers) {
            return
        }
        setLoadSubmit(true)
        setReady(false)

        if (idCustomersFilter) {
            setShowData(false)
        }

        Controllers.dashboard.get_customers_summary({
            p_id_customers: idCustomersFilter ? idCustomers : '',
            p_id_period: periodSelected
        }).then(res => {
            if (res.response !== 'success') {
                Helpers.toast.construct({
                    ...res,
                    toast
                })
                setReady(true)
                setLoadSubmit(false)
                setShowData(false);
                return;
            }

            if (idCustomersFilter) {
                setShowData(true)
            }
            setSummary({
                ...res.data,
                // point_current_customers: "1500",
            })
            setReady(true)
            setLoadSubmit(false)
        })
    }

    useEffect(() => {
        loadAll()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const dtRowsDetails = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_customers', text: 'ID', align: 'center' },
                { name: 'full_name_customers', text: 'Nombres', align: 'center' },
                ...(showRollOver ? [{ name: 'roll_over_customers', text: 'Puntos Roll Over', align: 'center' }] : []),
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing, showRollOver])

    const loadRowsDetails = e => {
        const { type } = e.currentTarget.dataset

        setRows([])
        setModalShow(true)
        setIsProcessing(true)
        let promises = []
        if (type === 'first_all') {
            setShowRollOver(true);
            setModalTitle('Descendencia Primer Nivel - Total')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 1,
                p_id_customers: idCustomersFilter ? idCustomers : '',
                p_qualifier: -1,
                p_status: -1,
                p_up: 0,
                p_id_period: periodSelected
            }))
        } else if (type === 'first') {
            setShowRollOver(true);
            setModalTitle('Descendencia Primer Nivel')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 1,
                p_id_customers: idCustomersFilter ? idCustomers : '',
                p_id_period: periodSelected
            }))
        } else if (type === 'first_6600') {
            setShowRollOver(true);
            setModalTitle('Descendencia Primer Nivel')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 1,
                p_id_customers: idCustomersFilter ? idCustomers : '',
                p_6600: 1,
                p_id_period: periodSelected
            }))
        } else if (type === 'second') {
            setShowRollOver(false);
            setModalTitle('Descendencia Segundo Nivel')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 2,
                p_id_customers: idCustomersFilter ? idCustomers : '',
                p_id_period: periodSelected
            }))
        } else if (type === 'third') {
            setShowRollOver(false);
            setModalTitle('Descendencia Tercer Nivel')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 3,
                p_id_customers: idCustomersFilter ? idCustomers : '',
                p_id_period: periodSelected
            }))
        } else if (type === 'fourth') {
            setShowRollOver(false);
            setModalTitle('Descendencia Cuarto Nivel')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 4,
                p_id_customers: idCustomersFilter ? idCustomers : '',
                p_id_period: periodSelected
            }))
        } else if (type === 'fifth') {
            setShowRollOver(false);
            setModalTitle('Descendencia Quinto Nivel')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 5,
                p_id_customers: idCustomersFilter ? idCustomers : '',
                p_id_period: periodSelected
            }))
        } else if (type === 'sixth') {
            setShowRollOver(false);
            setModalTitle('Descendencia Sexto Nivel - Infinito')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 6,
                p_up: 1,
                p_id_customers: idCustomersFilter ? idCustomers : '',
                p_id_period: periodSelected
            }))
        } else if (type === 'all') {
            setShowRollOver(false);
            setModalTitle('Descendencia Primer Nivel - Infinito')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 1,
                p_up: 1,
                p_qualifier: -1,
                p_status: -1,
                p_id_customers: idCustomersFilter ? idCustomers : '',
                p_id_period: periodSelected
            }))
        } else if (type === 'notMinPoint') {
            setShowRollOver(false);
            setModalTitle('Empresarios Independientes que no llegaron a puntos mínimos')
            promises.push(Controllers.dashboard.get_customers_by_nivel({
                p_nivel: 1,
                p_up: 1,
                p_qualifier: 0,
                p_status: -1,
                p_id_customers: idCustomersFilter ? idCustomers : '',
                p_id_period: periodSelected
            }))
        } else if (type === 'two-months') {
            setShowRollOver(false);
            setModalTitle('Empresarios Independientes inactivos por más de 2 meses')
            promises.push(Controllers.dashboard.get_customers_last_purchase_two_months())
        }

        if (promises.length) {
            Promise.all(promises).then(res => {
                setRows(res[0].data)
                setIsProcessing(false)
            })
        }
    }

    return <div className="form-row dashboard-workspace">
        {idCustomersFilter && <div className="col-12 mb-4">
            <div className="card">
                <div className="card-header">Buscar datos de cliente</div>
                <div className="card-body">
                    <FormCustom textButton={"Buscar"} onSubmit={_ => {
                        if (!periodSelected) {
                            Helpers.toast.construct({
                                response: 'warning',
                                message: 'Debe seleccionar un periodo',
                                toast
                            })
                            return false;
                        }
                        loadAll()
                    }} loadSubmit={loadSubmit}>
                        <Select
                            text="Periódo"
                            classNameParent="col-12 mb-2"
                            options={period.map(p => {
                                return {
                                    label: p.name_period,
                                    value: p.id_period
                                }
                            })}
                            onChange={e => setPeriodSelected(e.value)}
                        />
                        <Input
                            text="ID Cliente"
                            placeholder="ID Cliente"
                            type="number"
                            classNameParent="col-12 mb-2"
                            icon="fas fa-sort-numeric-up"
                            required
                            invalid="El campo es obligatorio."
                            value={idCustomers}
                            onChange={e => setIdCustomers(e.currentTarget.value)}
                        />
                    </FormCustom>
                </div>
            </div>
        </div>}
        {showData && <>
            <div className="col-12 dashboard-workspace__hero-wrap">
                <div className="dashboard-workspace__hero">
                    <Card className="dashboard-profile-card mb-4">
                        <Card.Body className="d-flex flex-column height-140">
                            <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                                <span className="dashboard-profile-card__label">MI NEGOCIO</span>
                                <div className="dashboard-profile-card__identity">
                                    <span className="dashboard-profile-card__avatar"><i className="far fa-user" /></span>
                                    <div>
                                        <h2>{summary.full_name_customers || 'Mi cuenta'}</h2>
                                        <p>ID {summary.id_customers || '—'} · Kit {summary.kit || '—'}</p>
                                    </div>
                                </div>
                                <div className="dashboard-profile-card__rank">
                                    <span>Mejor rango alcanzado</span>
                                    <strong>{summary.max_plan || 'En progreso'}</strong>
                                </div>
                            </ReactPlaceholder>
                        </Card.Body>
                    </Card>
                    <Card className="dashboard-period-card mb-4">
                        <Card.Body>
                            <ReactPlaceholder ready={ready} showLoadingAnimation rows={1}>
                                <span className="dashboard-profile-card__label">PERIODO ACTIVO</span>
                                <i className="far fa-calendar-check" />
                                <strong>{summary.name_period || 'Periodo actual'}</strong>
                                <small>Consulta el avance de tu organización</small>
                            </ReactPlaceholder>
                        </Card.Body>
                    </Card>
                </div>
            </div>
            {!idCustomersFilter && <div className="col-12">
                <FormCustom viewSubmit={false}>
                    <Select
                        text="Periódo"
                        classNameParent="col-12 mb-2"
                        options={period.map(p => {
                            return {
                                label: p.name_period,
                                value: p.id_period
                            }
                        })}
                        onChange={e => setPeriodSelected(e.value)}
                        append={[
                            <Button onClick={loadAll}>
                                <i className="fa fa-search"></i>
                            </Button>
                        ]}
                    />
                </FormCustom>
            </div>}

            {/* Nuevos cuadros de progreso */}
            {!idCustomersFilter && <div className="col-12">
                <div className="row">
                    {/* Cuadro de Calificación */}
                    <div className="col-md-6 col-12 mb-3">
                        <Card>
                            <Card.Body>
                                <ReactPlaceholder ready={ready} showLoadingAnimation rows={10}>
                                    <div className="d-flex align-items-center mb-4">
                                        <h6 className="mb-3 text-muted">Calificación</h6>
                                    </div>
                                    <div className="row align-items-center">
                                        {/* Columna izquierda - Círculo */}
                                        <div className="col-5 col-md-4 text-center">
                                            <div className="position-relative d-inline-block">
                                                <svg width="120" height="120" viewBox="0 0 120 120">
                                                    {/* Círculo de fondo */}
                                                    <circle
                                                        cx="60"
                                                        cy="60"
                                                        r="50"
                                                        fill="none"
                                                        stroke="#e9ecef"
                                                        strokeWidth="8"
                                                    />
                                                    {/* Círculo de progreso - más grueso para calificación */}
                                                    <circle
                                                        cx="60"
                                                        cy="60"
                                                        r="50"
                                                        fill="none"
                                                        stroke="#007bff"
                                                        strokeWidth="10"
                                                        strokeDasharray={`${2 * Math.PI * 50}`}
                                                        strokeDashoffset={`${2 * Math.PI * 50 * (1 - (summary?.plan_next?.point_personal && parseFloat(summary.point_current_customers?.replace(',', '')) > 0 ? Math.min(parseFloat(summary.point_current_customers?.replace(',', '')) / summary.plan_next.point_personal, 1) : 0))}`}
                                                        transform="rotate(-90 60 60)"
                                                        strokeLinecap="round"
                                                    />
                                                </svg>
                                                <div className="position-absolute" style={{
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)'
                                                }}>
                                                    <span className="h3 font-weight-bold text-primary">
                                                        {summary?.plan_next?.point_personal && parseFloat(summary.point_current_customers?.replace(',', '')) > 0 ?
                                                            Math.round(Math.min(100, (parseFloat(summary.point_current_customers?.replace(',', '')) / summary.plan_next.point_personal) * 100)) : 0
                                                        }%
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Columna derecha - Texto */}
                                        <div className="col-7 col-md-8">
                                            <div className="text-center">
                                                <p className="mb-2 text-muted">Estas a:</p>
                                                <h3 className="font-weight-bold text-primary mb-2">
                                                    {summary?.plan_next?.point_personal ?
                                                        Math.max(0, summary.plan_next.point_personal - parseFloat(summary.point_current_customers?.replace(',', '')))
                                                        : 0} PTS
                                                </h3>
                                                <small className="text-muted">para lograr tu calificación.</small>
                                            </div>
                                        </div>
                                    </div>
                                </ReactPlaceholder>
                            </Card.Body>
                        </Card>
                    </div>

                    {/* Cuadro de Siguiente Rango */}
                    <div className="col-md-6 col-12 mb-3">
                        <Card>
                            <Card.Body>
                                <ReactPlaceholder ready={ready} showLoadingAnimation rows={10}>
                                    <div className="d-flex align-items-center mb-4">
                                        <h6 className="text-muted align-self-center mb-0">Siguiente Rango <span className="font-weight-bold ml-2 align-self-center">{summary?.plan_next?.name_plan || 'N/A'}</span></h6>
                                    </div>
                                    <div className="row align-items-center">
                                        {/* Columna izquierda - Círculo */}
                                        <div className="col-5 col-md-4 text-center">
                                            <div className="position-relative d-inline-block">
                                                <svg width="120" height="120" viewBox="0 0 120 120">
                                                    {/* Círculo de fondo */}
                                                    <circle
                                                        cx="60"
                                                        cy="60"
                                                        r="50"
                                                        fill="none"
                                                        stroke="#e9ecef"
                                                        strokeWidth="8"
                                                    />
                                                    {/* Círculo de progreso - stroke uniforme para siguiente rango */}
                                                    <circle
                                                        cx="60"
                                                        cy="60"
                                                        r="50"
                                                        fill="none"
                                                        stroke="#007bff"
                                                        strokeWidth="8"
                                                        strokeDasharray={`${2 * Math.PI * 50}`}
                                                        strokeDashoffset={`${2 * Math.PI * 50 * (1 - (summary?.plan_next?.point_group === 0 ? 1 : (summary?.plan_next?.point_group > 0 && parseFloat(summary.point_group?.replace(',', '')) > 0 ? Math.min(parseFloat(summary.point_group?.replace(',', '')) / summary.plan_next.point_group, 1) : 0)))}`}
                                                        transform="rotate(-90 60 60)"
                                                        strokeLinecap="round"
                                                    />
                                                </svg>
                                                <div className="position-absolute" style={{
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)'
                                                }}>
                                                    <span className="h3 font-weight-bold text-primary">
                                                        {summary?.plan_next?.point_group === 0 ? 100 :
                                                            (summary?.plan_next?.point_group > 0 && parseFloat(summary.point_group?.replace(',', '')) > 0 ?
                                                                Math.round(Math.min(100, (parseFloat(summary.point_group?.replace(',', '')) / summary.plan_next.point_group) * 100)) : 0
                                                            )
                                                        }%
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Columna derecha - Texto */}
                                        <div className="col-7 col-md-8">
                                            <div className="text-center">
                                                <p className="mb-2 text-muted mt-2">Estas a:</p>
                                                <h3 className="font-weight-bold text-primary mb-2">
                                                    {summary?.plan_next?.point_group === 0 ? 0 :
                                                        (summary?.plan_next?.point_group > 0 ?
                                                            Math.max(0, summary.plan_next.point_group - parseFloat(summary.point_group?.replace(',', '')))
                                                            : 0)
                                                    } PTS
                                                </h3>
                                                <small className="text-muted">para lograr el volumen grupal.</small>
                                            </div>
                                        </div>
                                    </div>
                                </ReactPlaceholder>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </div>}

            <div className="col-12 mb-4">
                <Card>
                    <Card.Body className={'text-center d-flex justify-content-center'}>
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <small className='text-muted align-self-center mr-2'>
                                <a href={Helpers.config.convertUrl({
                                    url: '/ecommerce-publico/' + summary.id_customers
                                })} rel="noreferrer" target='_blank'>
                                    Ver mi Ecommerce Público
                                </a>
                            </small>

                            <div>
                                <Button onClick={() => {
                                    var textArea = document.createElement("textarea");
                                    textArea.value = Helpers.config.apiUrl({
                                        url: '/ecommerce-publico/' + summary.id_customers
                                    });

                                    textArea.style.top = "0";
                                    textArea.style.left = "0";
                                    textArea.style.position = "fixed";

                                    document.body.appendChild(textArea);
                                    textArea.focus();
                                    textArea.select();

                                    try {
                                        document.execCommand('copy');
                                    } catch (err) {
                                    }

                                    document.body.removeChild(textArea);
                                }} size="sm" variant="outline-primary">
                                    <i className='fa fa-copy'></i>

                                </Button>
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-12 mb-4">
                <Card>
                    <Card.Body className={'text-center d-flex justify-content-center'}>
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <small className='text-muted align-self-center mr-2'>
                                <a href={Helpers.config.convertUrl({
                                    url: '/alta-de-cliente/upline/' + summary.id_customers
                                })} rel="noreferrer" target='_blank'>
                                    Comparte tu Link de Registro
                                </a>
                            </small>

                            <div>
                                <Button onClick={() => {
                                    var textArea = document.createElement("textarea");
                                    textArea.value = Helpers.config.apiUrl({
                                        url: '/alta-de-cliente/upline/' + summary.id_customers
                                    });

                                    textArea.style.top = "0";
                                    textArea.style.left = "0";
                                    textArea.style.position = "fixed";

                                    document.body.appendChild(textArea);
                                    textArea.focus();
                                    textArea.select();

                                    try {
                                        document.execCommand('copy');
                                    } catch (err) {
                                    }

                                    document.body.removeChild(textArea);
                                }} size="sm" variant="outline-primary">
                                    <i className='fa fa-copy'></i>

                                </Button>
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-12 mb-4">
                <Card>
                    <Card.Body className={'text-center d-flex justify-content-center'}>
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <small className='text-muted align-self-center mr-2'>
                                <a href={Helpers.config.apiUrl({
                                    url: '/red/order/red/' + summary.id_customers + '?jwt=' + jwt
                                })} rel="noreferrer" target='_blank'>
                                    Ver Descendencia Ordenada
                                </a>
                            </small>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            {/* {summary?.plan_next && <>
                {parseInt(summary.point_current_customers?.replace(',', '')) < summary.plan_next.point_personal && <div className="col-12">
                    <div className="alert alert-info">
                        <strong>Puntos faltantes para siguiente rango: {summary.plan_next.point_personal - parseInt(summary.point_current_customers?.replace(',', ''))}</strong>
                    </div>
                </div>}
            </>} */}
            {parseInt(summary?.first_nivel) === 0 && <div className='col-12'>
                <div className="alert alert-warning">
                    <strong>No tienes clientes registrados.</strong>
                </div>
            </div>}
            {summary?.days_no_register_customers && <div className='col-12'>
                <div className="alert alert-warning">
                    <strong>No has registrado clientes hace: {summary.days_no_register_customers}</strong>
                </div>
            </div>}
            {summary.id_kit === 'basico' && <div className='col-12'>
                <div className="alert alert-warning">
                    <strong>Ocupas un kit premium para alcanzar el siguiente rango</strong>
                </div>
            </div>}
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className={'text-center d-flex flex-column height-110 position-relative' + (parseInt(summary.point_current_customers?.replace(',', '')) >= Helpers.config.pointMinRange ? ' bg-success text-white' : '')}>
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Puntos</span>
                            <strong className="f-size-18">{summary.point_current_customers}</strong>
                            {parseInt(summary.point_current_customers?.replace(',', '')) >= Helpers.config.pointMinRange ? <div className="position-absolute d-flex justify-content-center" style={{ bottom: 10, width: 'calc(100% - 2.50rem)' }}>
                                <strong>¡FELICIDADES! Ya calificaste.</strong>
                            </div> : ''}
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Valor Negocio</span>
                            <strong className="f-size-18">{summary.point_business_customers}</strong>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Rango</span>
                            <div>
                                {summary.icon_plan ? <>
                                    <img src={Helpers.config.resourcesUrl({ url: summary.icon_plan })} style={{
                                        maxWidth: 40
                                    }} alt="" />
                                    <strong>{summary.name_plan}</strong>
                                </> : <strong>{summary.name_plan}</strong>}
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Puntos Roll Over</span>
                            <div>
                                <strong className="f-size-18 align-self-center">{summary.roll_over_customers}</strong>
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Puntos faltantes para <strong>{summary.point_next_level_range}</strong></span>
                            <div>
                                <strong className="f-size-18 align-self-center">{summary.point_next_level}</strong>
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110 position-relative">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">1er Nivel</span>
                            <div>
                                <strong className="f-size-18 align-self-center">{summary.first_nivel}</strong>
                                {<i className="fas fa-info-circle ml-2 text-info cur-pointer align-self-center" data-type="first_all" onClick={loadRowsDetails}></i>}
                            </div>
                            {parseInt(summary.first_nivel) < summary?.plan_next?.qualifiers_first_level ? <div className="position-absolute d-flex justify-content-center" style={{ bottom: 10, width: 'calc(100% - 2.50rem)' }}>
                                <strong>Necesitas {summary?.plan_next?.qualifiers_first_level} para siguiente rango</strong>
                            </div> : ''}
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110 position-relative">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Calificados 1er Nivel (3300)</span>
                            <div>
                                <strong className="f-size-18 align-self-center">{summary.qualifier_first_nivel}</strong>
                                {<i className="fas fa-info-circle ml-2 text-info cur-pointer align-self-center" data-type="first" onClick={loadRowsDetails}></i>}
                            </div>
                            {parseInt(summary.qualifier_first_nivel?.replace(',', '')) < summary?.plan_next?.qualifiers_first_level ? <div className="position-absolute d-flex justify-content-center" style={{ bottom: 10, width: 'calc(100% - 2.50rem)' }}>
                                <strong>Necesitas {summary?.plan_next?.qualifiers_first_level} para siguiente rango</strong>
                            </div> : ''}
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110 position-relative">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Calificados 1er Nivel (6600)</span>
                            <div>
                                <strong className="f-size-18 align-self-center">{summary.qualifier_first_nivel_6600}</strong>
                                {<i className="fas fa-info-circle ml-2 text-info cur-pointer align-self-center" data-type="first_6600" onClick={loadRowsDetails}></i>}
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110 position-relative">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Puntos Grupales de toda la Red</span>
                            <strong className="f-size-18 align-self-center">{summary.point_group_red}</strong>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Personas inactivas por más de 2 meses</span>
                            <div>
                                <strong className="f-size-18 align-self-center">{summary.qty_customers_inactive_two_months}</strong>
                                {parseInt(summary.current_period) === 1 && <i className="fas fa-info-circle ml-2 text-info cur-pointer align-self-center" data-type="two-months" onClick={loadRowsDetails}></i>}
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Cantidad de Empresarios Independientes en tu Red Activos e Inactivos</span>
                            <div>
                                <strong className="f-size-18 align-self-center">{summary.qty_customers_active_and_inactive}</strong>
                                {parseInt(summary.current_period) === 1 && <i className="fas fa-info-circle ml-2 text-info cur-pointer align-self-center" data-type="all" onClick={loadRowsDetails}></i>}
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Empresarios Independientes que han comprado, pero no han alcanzado los {Helpers.config.pointMinRange} puntos de calificación</span>
                            <div>
                                <strong className="f-size-18 align-self-center">{summary.qty_customers_without_min_points}</strong>
                                {parseInt(summary.current_period) === 1 && <i className="fas fa-info-circle ml-2 text-info cur-pointer align-self-center" data-type="notMinPoint" onClick={loadRowsDetails}></i>}
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Comisiones del Periodo</span>
                            <div>
                                <strong className="f-size-18 align-self-center">{summary.total_period}</strong>
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            {/* <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">ELEVATE IRAPUATO ' NOV 2024</span>
                            <div>
                                <strong className="f-size-18 align-self-center">{summary.product_convencion}</strong>
                            </div>
                            {parseInt(summary.product_convencion) < 10 && <div className="position-absolute d-flex justify-content-center" style={{ bottom: 10, width: 'calc(100% - 2.50rem)' }}>
                                <strong>Te faltan {10 - parseInt(summary.product_convencion)} para completar tu entrada</strong>
                            </div>}
                            {parseInt(summary.product_convencion) === 10 && <div className="position-absolute d-flex justify-content-center" style={{ bottom: 10, width: 'calc(100% - 2.50rem)' }}>
                                <strong>Ya tienes tu entrada</strong>
                            </div>}
                            {parseInt(summary.product_convencion) > 10 && <>
                                {!(parseInt(summary.product_convencion) / 10).toString().includes('.') && <div className="position-absolute d-flex justify-content-center" style={{ bottom: 10, width: 'calc(100% - 2.50rem)' }}>
                                    <strong>Tienes {parseInt(summary.product_convencion) / 10} entradas</strong>
                                </div>}
                                {(parseInt(summary.product_convencion) / 10).toString().includes('.') && <div className="position-absolute d-flex justify-content-center" style={{ bottom: 10, width: 'calc(100% - 2.50rem)' }}>
                                    <strong>Tienes {parseInt(parseInt(summary.product_convencion) / 10)} entrada(s). Te faltan {10 - (
                                        parseFloat(parseFloat((parseFloat(summary.product_convencion) / 10) - parseInt(parseInt(summary.product_convencion) / 10)).toFixed(2))
                                        * 10)} para completar una entrada más</strong>
                                </div>}
                            </>}
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div> */}
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Cantidad Activos</span>
                            <div>
                                <strong className="f-size-18 align-self-center">{summary.qty_activos}</strong>
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Cantidad Calificados</span>
                            <div>
                                <strong className="f-size-18 align-self-center">{summary.qty_calificados}</strong>
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Cantidad Inscritos</span>
                            <div>
                                <strong className="f-size-18 align-self-center">{summary.qty_inscritos}</strong>
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            {/* <div className="col-md-4 col-12 col-sm-6 mb-4">
                <Card>
                    <Card.Body className="text-center d-flex flex-column height-110">
                        <ReactPlaceholder ready={ready} showLoadingAnimation rows={2}>
                            <span className="mb-2">Total de Comisiones Cobradas</span>
                            <strong className="f-size-18 align-self-center">{summary.total_earnings}</strong>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div> */}
        </>}
        <Modal show={modalShow} onHide={_ => setModalShow(false)} backdrop="static" size="lg">
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {dtRowsDetails}
            </Modal.Body>
        </Modal>

        {!idCustomersFilter && id_type_money === 2 && <>
            <Modal show={terms} backdrop="static" size="lg">
                <Modal.Header>
                    <Modal.Title as="div">Aceptar Terminos y Condiciones</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {id_type_money === 2 && <iframe src={Helpers.config.resourcesUrl({ url: '/files/contrato/CONTRATO_TONIC_MX.pdf' })} title="CONTRATO_TONIC_MX.pdf" width="100%" height="500" />}

                    {id_type_money === 1 && <iframe src={Helpers.config.resourcesUrl({ url: '/files/contrato/CONTRATO_TONIC_USA.pdf' })} title="CONTRATO_TONIC_USA.pdf" width="100%" height="500" />}

                    <div className='mt-4'>
                        <FormCustom onSubmit={_ => {
                            if (!contratoUsaData.federal_tax && id_type_money === 1) {
                                Helpers.toast.construct({
                                    response: 'warning',
                                    message: 'Select appropriate box for federal tax classification',
                                    toast
                                })
                                return false
                            }

                            setTerms(false);
                            Controllers.customers.terms_accepted(id_type_money === 1 ? {
                                p_contrato_json_usa: {
                                    p_name: contratoUsaData.name,
                                    p_business_name: contratoUsaData.business_name,
                                    p_federal_tax: contratoUsaData.federal_tax,
                                    p_federal_tax_add: contratoUsaData.federal_tax_add,
                                    p_exempt_pay_code: contratoUsaData.exempt_pay_code,
                                    p_exemption_fatca: contratoUsaData.exemption_fatca,
                                    p_address: contratoUsaData.address,
                                    p_city_state_zip: contratoUsaData.city_state_zip,
                                    p_list_account_numbers: contratoUsaData.list_account_numbers,
                                    p_requests_name: contratoUsaData.requests_name,
                                    p_social_security_number: contratoUsaData.social_security_number,
                                    p_employer_identification_number: contratoUsaData.employer_identification_number
                                },
                                p_id_type_money: id_type_money
                            } : {})
                        }} className="form-row" viewSubmit={false}>
                            {id_type_money === 1 && <>
                                <Input
                                    type="text"
                                    text="Name"
                                    classNameParent="col-md-6 col-12 mb-3"
                                    required
                                    onChange={e => setContratoUsaData({ ...contratoUsaData, name: e.target.value })}
                                />
                                <Input
                                    type="text"
                                    text="Business name"
                                    classNameParent="col-md-6 col-12 mb-3"
                                    onChange={e => setContratoUsaData({ ...contratoUsaData, business_name: e.target.value })}
                                />
                                <Select
                                    text="Select appropriate box for federal tax classification"
                                    classNameParent="col-md-6 col-12 mb-3"
                                    options={[
                                        { value: 1, label: 'Individual/sole proprietor or single-member LLC' },
                                        { value: 2, label: 'C Corporation' },
                                        { value: 3, label: 'S Corporation' },
                                        { value: 4, label: 'Partnership' },
                                        { value: 5, label: 'Trust/estate' },
                                        { value: 6, label: 'Limited liability company' },
                                        { value: 7, label: 'Other' },
                                    ]}
                                    onChange={e => setContratoUsaData({ ...contratoUsaData, federal_tax: e.label })}
                                    append={contratoUsaData.federal_tax === 'Limited liability company' || contratoUsaData.federal_tax === 'Other' ? [
                                        <Input type="text" onChange={e => setContratoUsaData({ ...contratoUsaData, federal_tax_add: e.target.value })} placeholder={contratoUsaData.federal_tax === 'Limited liability company' ? 'C, S or P' : ''} />
                                    ] : []}
                                />
                                <Input
                                    type="text"
                                    text="Exempt payee code"
                                    classNameParent="col-md-6 col-12 mb-3"
                                    onChange={e => setContratoUsaData({ ...contratoUsaData, exempt_pay_code: e.target.value })}
                                />
                                <Input
                                    type="text"
                                    text="Exempt from FATCA code"
                                    classNameParent="col-md-6 col-12 mb-3"
                                    onChange={e => setContratoUsaData({ ...contratoUsaData, exemption_fatca: e.target.value })}
                                />
                                <Input
                                    type="text"
                                    text="Address"
                                    classNameParent="col-md-6 col-12 mb-3"
                                    onChange={e => setContratoUsaData({ ...contratoUsaData, address: e.target.value })}
                                />
                                <Input
                                    type="text"
                                    text="City, state, and ZIP code"
                                    classNameParent="col-md-6 col-12 mb-3"
                                    onChange={e => setContratoUsaData({ ...contratoUsaData, city_state_zip: e.target.value })}
                                />
                                <Input
                                    type="text"
                                    text="List account numbers"
                                    classNameParent="col-md-6 col-12 mb-3"
                                    onChange={e => setContratoUsaData({ ...contratoUsaData, list_account_numbers: e.target.value })}
                                />
                                <Input
                                    type="text"
                                    text="Requests'name and address"
                                    classNameParent="col-md-6 col-12 mb-3"
                                    onChange={e => setContratoUsaData({ ...contratoUsaData, requests_name: e.target.value })}
                                />
                                <Input
                                    type="text"
                                    text="Social security number"
                                    classNameParent="col-md-6 col-12 mb-3"
                                    onChange={e => setContratoUsaData({ ...contratoUsaData, social_security_number: e.target.value })}
                                />
                                <Input
                                    type="text"
                                    text="Employer identification number"
                                    classNameParent="col-md-6 col-12 mb-3"
                                    onChange={e => setContratoUsaData({ ...contratoUsaData, employer_identification_number: e.target.value })}
                                />
                            </>}
                            <div className="col-12 mt-4 d-flex justify-content-center">
                                <Button type="submit" variant="success" className='mr-4'>
                                    <i className='fa fa-check mr-2'></i>
                                    <span>Aceptar</span>
                                </Button>
                                <Button type="button" variant="dark" onClick={_ => {
                                    Helpers.localStorage.clearJWT();
                                    window.location.href = Helpers.config.convertUrl({ url: '/' + (parseInt(type) === 1 ? 'login/empresariosindependientes' : '') });
                                }}>
                                    <i className='fas fa-sign-out-alt mr-2'></i>
                                    <span>Salir</span>
                                </Button>
                            </div>
                        </FormCustom>
                    </div>
                </Modal.Body>
            </Modal>
        </>}
    </div>
}

Dashboard.defaultProps = {
    idCustomersFilter: false
}

export default Dashboard
